import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class HttpHelperService {

    buildHttpParams(keys: string[], values: string[]): HttpParams {
        let params = new HttpParams();
        for (let i = 0; i < keys.length; i++) params = params.set(keys[i], values[i]);
        return params;
    }
}